<template>
    <div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Manage KSD Scenarios</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>

            <div class="p-8">
                <div class="flex items-center space-x-3">
                    <div class="flex items-center">
                        <label class="mb-0 uppercase text-sm mr-2" for="scenario">Scenarios</label>
                        <select name="scenario" class="form-select form-select-blue" v-model="selectedScenario">
                            <option v-for="(scenario, index) in allScenarios" :key="scenario.id" :value="scenario.id" :selected="index === 0">{{ scenario.name }}</option>
                        </select>
                    </div>
                    <div v-if="allScenarios.length > 1" @click="confirmDeleteScenario">
                        <inline-svg name="trash"></inline-svg>
                    </div>
                    <div @click="createScenario">
                        <inline-svg name="add"></inline-svg>
                    </div>
                </div>

                <form class="mt-10">
                    <div class="flex mb-4 border-b border-gray-300 pb-4">
                        <label class="w-96 text-lg" for="name">Name</label>
                        <input type="text" size="30" name="name" class="form-input" v-model="scenarioData.name">
                    </div>
                    <div class="flex items-center mb-4 border-b border-gray-300 pb-4">
                        <div class="w-96 flex flex-col">
                            <label class="text-lg mb-2">Default Scenario</label>
                            <p class="max-w-sm text-xs leading-normal w-4/5">You can have one default scenario.  The default scenario will be used to calculate base scores for your Comps or Tour.</p>
                        </div>
                        <div class="flex-1">
                            <toggle-button v-model="scenarioData.is_default" color="#38C172" sync></toggle-button>
                        </div>
                    </div>
                    <div v-if="$gate.isAdmin()" class="flex items-center mb-4 border-b border-gray-300 pb-4">
                        <div class="w-96 flex flex-col">
                            <label class="text-lg mb-2">Negotiation Mode</label>
                            <p class="max-w-sm text-xs leading-normal w-4/5">When negotiation mode is turned on Comp addresses will be hidden from view when viewing your project.</p>
                        </div>
                        <div class="flex-1">
                            <toggle-button v-model="scenarioData.negotiation_mode" color="#38C172" sync></toggle-button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="bg-gray-100 p-4">
                <div class="text-right">
                    <button class="btn btn-secondary mr-2" @click.prevent="hideModal">Close</button>
                    <button class="btn btn-green" @click.prevent="save">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ksdableId: {
                type: Number,
                required: true
            },

            ksdableType: {
                type: String,
                required: true
            },

            scenarios: {
                type: [Array, Object],
                default: () => []
            },

            scenario: {
                type: [Array, Object],
                default: () => ({})
            }
        },

        data() {
            return {
                allScenarios: this.scenarios,
                selectedScenario: this.scenario.id,
            }
        },

        computed: {
            scenarioData() {
                if (this.selectedScenario == undefined) {
                    return this.allScenarios[0];
                }

                return _.find(this.allScenarios, ['id', this.selectedScenario]);
            }
        },

        methods: {
            createScenario() {
                this.allScenarios.push({
                    id: 'new',
                    name: 'New Scenario',
                    ksds: [],
                    is_default: 0,
                    negotiation_mode: 0,
                    ksdable_id: this.ksdableId,
                    ksdable_type: this.ksdableType
                })

                this.selectedScenario = 'new';
            },

            save() {
                const url = this.scenarioData.id == "new" ? '/ksds/scenarios' : '/ksds/scenarios/' + this.scenarioData.id;
                
                this.scenarioData._method = this.scenarioData.id == "new" ? "POST" : "PATCH";

                axios.post(url, this.scenarioData).then((response) => {
                    this.allScenarios.pop();
                    this.allScenarios.push(response.data.scenario);

                    this.selectedScenario = response.data.scenario.id;

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });

                    this.hideModal();     
                }).catch((response) => {
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: response.data.message
                    });
                })
            },

            removeKSDScenario() {
                this.allScenarios = _.remove(this.allScenarios, (scenario) => { return scenario.id != this.selectedScenario });

                this.selectedScenario = this.allScenarios[0].id;
            },

            confirmDeleteScenario() {
                if (this.allScenarios.length == 1) {
                    return this.$swal({
                        title: 'Cannot Delete Last Scenario',
                        text: "You must have at least one KSD scenario",
                        type: 'warning',
                        buttonsStyling: false,
                        confirmButtonText: 'Ok',
                        confirmButtonClass: 'btn btn-green',
                    });
                }

                if (this.selectedScenario == "new") {
                    this.removeKSDScenario();
                    
                    return;
                }

                this.$swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to delete this Scenario?",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteScenario();
                    }
                });
            },

            deleteScenario() {
                axios.delete('/ksds/scenarios/' + this.selectedScenario)
                    .then((response) => {
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });

                        this.removeKSDScenario();
                    })
                    .catch((error) => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    }
                );
            },
        }
    }
</script>